// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo
import { TeamSettings } from './TeamSettings';

import type { TeamSettingsModelType } from 'common/models/flow/TeamSettings';
import type { TeamModelType } from 'common/models/flow/Team';

export type TeamSettingsReducerStateModelType = {
    teamSettingsMap: { [key: TeamModelType]: TeamSettingsModelType },
    isLoading: boolean
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class TeamSettingsReducerState extends ImmutableModel {
    static fromJS(
        json: TeamSettingsReducerStateModelType
    ): TeamSettingsReducerState {
        const state: Object = Object.assign({}, json);
        state.teamSettingsMap = Immutable.Map(state.teamSettingsMap).map(item =>
            TeamSettings.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): TeamSettingsReducerStateModelType {
        return {
            teamSettingsMap: this.teamSettingsMap
                .map(item => item.toJS())
                .toObject(),
            isLoading: this.isLoading
        };
    }

    get teamSettingsMap(): Immutable.Map<Team, TeamSettings> {
        return this._state.get('teamSettingsMap');
    }

    setTeamSettingsMap(
        teamSettingsMap: Immutable.Map<Team, TeamSettings>
    ): this {
        return this.clone(this._state.set('teamSettingsMap', teamSettingsMap));
    }

    get isLoading(): boolean {
        return this._state.get('isLoading');
    }

    setIsLoading(isLoading: boolean): this {
        return this.clone(this._state.set('isLoading', isLoading));
    }
}
